import { render, staticRenderFns } from "./affiliate-review-page-questions.vue?vue&type=template&id=2c5aafd2&scoped=true&"
import script from "./affiliate-review-page-questions.vue?vue&type=script&lang=ts&"
export * from "./affiliate-review-page-questions.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-review-page-questions.vue?vue&type=style&index=0&id=2c5aafd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5aafd2",
  null
  
)

export default component.exports